import type { BoostState } from './types';

const initialState: BoostState = {
  multiplier: 0,
  boost_refresh_interval: 0,
  resets_at: 0,
  duration: 0,
  remaining: 0,
  boost_id: '',
  boost_refresh_amount: 0,
  expires_at: 0,
  is_super_boost: false,
  boost_refresh_interval_unit: 'm',
  boost_ended: false,
  boostTimerStarted: false,
  sourceVersion: 0, // 3 - boost paywall with superboost, 4 - superboost paywall
  is_primetime_boost: false,
  primetime_boost_remaining: 0,
  consumed_from: 0,
};

export default initialState;
